import { render } from "./PersonalEdit.vue?vue&type=template&id=4ca7b1b7"
import script from "./PersonalEdit.vue?vue&type=script&lang=js"
export * from "./PersonalEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/jpom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__